import React from 'react';

import { FORM_ERROR } from 'final-form';

import { SimpleObject } from '@hrlogics/helper-types';

import { CompanyType, useValidateSignupEmployeePinOrSsnLazyQuery } from 'src/api';
import { FORM_ERROR_KEY } from 'src/constants/signup';
import { PinFormValues } from 'src/types/signup';

import { useNotification } from '../app';

type PinFormSubmitHandlerHookParams = {
  companyId: string;
  companyType: CompanyType;
  updateFormData: (data: SimpleObject) => void;
  setEmployeeSignupToken: (token: string | null) => void;
  goToNextStep: () => void;
};

export const usePinFormSubmitHandler = ({
  companyId,
  companyType,
  updateFormData,
  setEmployeeSignupToken,
  goToNextStep,
}: PinFormSubmitHandlerHookParams) => {
  const { createApolloContext } = useNotification();

  const [validateSignupPinOrSsn] = useValidateSignupEmployeePinOrSsnLazyQuery({
    context: createApolloContext(),
  });

  const handlePinFormSubmit = React.useCallback(
    async (formValues: PinFormValues) => {
      const { data } = await validateSignupPinOrSsn({
        variables: {
          pinOrSsn: formValues.pin,
          companyId,
          companyType,
        },
      });

      const employeeSignupToken = data?.validateSignupEmployeePinOrSsn.employeeSignupToken;
      if (!employeeSignupToken) {
        return { [FORM_ERROR]: FORM_ERROR_KEY.PIN_NOT_FOUND };
      }

      updateFormData({ pin: formValues.pin });
      setEmployeeSignupToken(employeeSignupToken);
      return goToNextStep();
    },
    [
      companyId,
      companyType,
      validateSignupPinOrSsn,
      updateFormData,
      setEmployeeSignupToken,
      goToNextStep,
    ],
  );

  return { handlePinFormSubmit };
};
